<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <!-- <h2>{{quests['data']?.title}}</h2> -->
                    <h2> {{'purchaseInfo' | translate}} </h2>
                    <ul>
                        <!-- <li><a routerLink="/">Home</a></li> -->
                        <li><a href="#home">Home</a></li>
                        <li><a href="#blog">Quest</a></li>
                        <li>
                            <a (click)="goListQuests()">{{
                                questTypes["name"]
                            }}</a>
                        </li>
                        <li>{{ quest["title"] }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape">
        <div class="shape-1">
            <img src="assets/img/shape/1.png" alt="image" />
        </div>
        <div class="shape-2 rotateme">
            <img src="assets/img/shape/2.png" alt="image" />
        </div>
        <div class="shape-3">
            <img src="assets/img/shape/3.svg" alt="image" />
        </div>
        <div class="shape-4">
            <img src="assets/img/shape/4.svg" alt="image" />
        </div>
        <div class="shape-5">
            <img src="assets/img/shape/5.png" alt="image" />
        </div>
    </div>
</div>

<section class="single-blog-area pt-100 pb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="blog-details-desc">
                    <div class="article-image first pb-2">
                        <h3 class="comments-title"> {{'questInfo' | translate}} </h3>

                        <div class="quest_info">
                            <div class="quest_img">
                                <img
                                    src="{{
                                        quest['imagePath'] == null
                                            ? 'https://via.placeholder.com/250x100.png'
                                            : quest['imagePath']
                                    }}"
                                    id="main-img"
                                    alt="image"
                                    width="250px"
                                    height="100px"
                                />
                            </div>
                            <div class="quest_name">
                                {{ quest["title"] }}
                            </div>
                        </div>
                    </div>

                    <div class="article-image secend pt-4 pb-4">
                        <h3 class="comments-title"> {{'customerInfo' | translate}} </h3>
                        <br />
                        <h5 class="quest-name"> {{'contactInfo' | translate}} </h5>
                        {{'contactInfoText' | translate}}
                        <form id="contactForm">
                            <!-- <div class="row">
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            name="name"
                                            id="name"
                                            class="form-control customer-name"
                                            required
                                            placeholder="{{
                                                'left_contact_name' | translate
                                            }}"
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-6">
                                    <div class="form-group">
                                        <input
                                            type="email"
                                            name="email"
                                            id="email"
                                            class="form-control customer-email"
                                            required
                                            placeholder="Email"
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-6">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            name="phone_number"
                                            id="phone_number"
                                            class="form-control customer-phone"
                                            required
                                            placeholder="{{
                                                'left_contact_phone' | translate
                                            }}"
                                        />
                                    </div>
                                </div>
                            </div> -->
                            <br /><br />
                            <h5 class="quest-name">
                                {{'accountLogin' | translate}}
                            </h5>
                            <div *ngIf="sessionLogin == null; else hasSessionLogin">
                                    {{'authen' | translate}}
                                <div class="btnLogin pt-2">
                                    <div class="googleBtn">
                                        <button
                                            type="button"
                                            class="login-with-google-btn"
                                            (click)="loginWithGoogle()"
                                        >
                                            {{'btn_loginGG' | translate}}
                                        </button>
                                    </div>
                                    <div class="FacebookBtn">
                                        <button class="loginBtn loginBtn--facebook" (click)="loginWithFacebook()">
                                            {{'btn_loginFB' | translate}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <ng-template #hasSessionLogin>
                                <h6 style="color:#47d764;"> {{'logedIn' | translate}} </h6>
                            </ng-template>
                            <!-- <button (click)="loginWithFacebook()">Sign in with Facebook</button> -->
                        </form>
                    </div>
                </div>
                <br/>
                <div class="payment-info">
                    <h3> {{'paymentMethod' | translate}} </h3>
                    {{'paymentMethodText' | translate}}
                    <div class="logo">
                        <img width="45px" height="45px" alt="logo-momo" src="assets/img/logo/momo.png" class="rounded-3">
                    </div>
                </div>
                <br/>
                <div class="voucher">
                    <div class="voucher-text">
                        <h5> {{'voucher' | translate}} </h5>
                    </div>
                    <div class="form-group">
                        <input
                            type="text"
                            name="voucher-input"
                            class="form-control voucher-input"
                            placeholder=" {{'voucher' | translate}} "
                            [(ngModel)]="voucher"
                        />
                    </div>
                    <div class="apply-btn">
                        <a class="default-btn" (click)="applyVoucher()"
                            > {{'btn_apply' | translate}} <span></span>
                        </a>
                    </div>
                    <div class="voucher-msg" *ngIf="msg_login == 'cannot-use' " style="color: #007bff">
                        {{'cantUseVoucher' | translate}}
                    </div>
                    <div class="voucher-msg" *ngIf="isVoucher == 'exist'" style="color: #47d764;">
                        {{'voucherSuccess' | translate}} {{resVoucherChecking?.numOfDiscount}}% {{'msg_success' | translate}}
                    </div>
                    <div class="voucher-msg" style="color: red;" *ngIf="(isVoucher == 'not-exist') && isApply">
                        {{'voucherInvalid' | translate}}
                    </div>
                </div>
                <div class="article-content">
                    <blockquote class="wp-block-quote">
                        <h5> {{'notes' | translate}} </h5>
                        <ul class="features-list">
                            <li>
                                <i><fa-icon [icon]="faCheck"></fa-icon></i>
                                {{'note1' | translate}}
                            </li>
                            <li>
                                <i><fa-icon [icon]="faCheck"></fa-icon></i>
                                {{'note2' | translate}}
                            </li>
                            <li>
                                <i><fa-icon [icon]="faCheck"></fa-icon></i>
                                {{'note3' | translate}}
                            </li>
                            <li>
                                <i><fa-icon [icon]="faCheck"></fa-icon></i>
                                {{'note4' | translate}}
                            </li>
                            <li>
                                <i><fa-icon [icon]="faCheck"></fa-icon></i>
                                {{ "purchase_msg1" | translate }}
                                <b> {{'purchase_msg3' | translate}} </b>
                                {{ "purchase_msg2" | translate }}
                                <b>{{ "purchase_msg4" | translate }}</b>
                            </li>
                        </ul>
                    </blockquote>
                </div>
            </div>

            <div class="col-lg-4 col-md-12 purchase-bg">
                <div class="single-pricing-table">
                    <div class="pricing-header">
                        <div class="unit-price pdleft-right">
                            <div class="text_flex"> {{'unitPrice' | translate}} </div>
                            <div>
                                {{ quest["price"] | number }} <sup>đ</sup>
                            </div>
                        </div>
                        <div class="quantity pdleft-right">
                            <div class="text_flex">{{'quantity' | translate}}</div>
                            <div>{{ quantity }}</div>
                        </div>
                        <div class="total pdleft-right">
                            <div class="text_flex"><b>{{'total' | translate}}</b></div>
                            <div>
                                <!-- <b [ngStyle]=" {'text-decoration' : isVoucher ? 'line-through' : ''} ">{{ total | number }} <sup>đ</sup></b> -->
                                <b [ngClass]="{'originPrice': isVoucher=='exist'}">{{ total | number }} <sup *ngIf="isVoucher=='not-exist'">đ</sup></b>
                                <span *ngIf="isVoucher=='exist'">&nbsp;<b>{{totalSale | number}} <sup>đ</sup></b></span>
                            </div>
                        </div>
                    </div>

                    <ul class="pricing-features">
                        <li>
                            <div class="quantity col-lg-12 col-sm-12">
                                {{'updateQuestQuantity' | translate}}
                            </div>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <button
                                        class="input-group-text minus"
                                        (click)="count_quantity('-')"
                                    >
                                        <fa-icon
                                            [icon]="faMinus"
                                            class="icon_minus"
                                        ></fa-icon>
                                    </button>
                                </div>
                                <input
                                    type="number"
                                    class="form-control"
                                    id="inlineFormInputGroupUsername2"
                                    value="{{ quantity }}"
                                    [min]="1"
                                    [max]="99"
                                    [(ngModel)]="quantity"
                                    name="quantity"
                                    (keyup)="keyUpTotal()"
                                />
                                <div class="input-group-prepend">
                                    <button
                                        class="input-group-text add"
                                        (click)="count_quantity('+')"
                                    >
                                        <fa-icon
                                            [icon]="faPlus"
                                            class="icon_add"
                                        ></fa-icon>
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ul>

                    <!-- End Modal -->
                    <div class="pricing-btn">
                        <button class="default-btn" (click)="createBill()" [disabled]="quantity <= 0 ? true : false"
                            > {{'btn_continue' | translate}} <span></span
                        ></button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<!-- <app-subscribe></app-subscribe> -->
